export default "__VITE_ASSET__75cffba7__"